import base from './base';
import palette from './palette';

const tabs = {
  MuiTabs: {
    defaultProps: {
      TabIndicatorProps: { style: { display: 'none' } },
    },
    styleOverrides: {
      root: { minHeight: 30 },
      flexContainer: { gap: 6 },
    },
  },
  MuiTab: {
    styleOverrides: {
      root: {
        border: '1px solid',
        borderRadius: base.shape.borderRadius,
        borderColor: palette.grey[600],
        color: palette.text.primary,
        fontSize: '1rem',
        fontWeight: 500,
        minHeight: 30,
        paddingBlock: '3px',
        textTransform: 'none' as const,
        '&.Mui-selected, &:hover': {
          color: palette.common.white,
          backgroundColor: palette.primary.main,
          borderColor: palette.primary.main,
        },
        '&.Mui-disabled': {
          backgroundColor: palette.grey[150],
          borderColor: palette.grey[150],
          color: palette.text.secondary,
        },
      },
    },
  },
};

export default tabs;
